import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=337ad22e&scoped=true&"
import script from "./Kontakt.vue?vue&type=script&lang=js&"
export * from "./Kontakt.vue?vue&type=script&lang=js&"
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=337ad22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ad22e",
  null
  
)

export default component.exports